import { Action } from '@ngrx/store'
import { translation, TranslationRow } from './i18n.interface'
import * as i18nTypes from './i18n.types'

export class FetchAvaliableLanguagesRequest implements Action {
  readonly type = i18nTypes.FETCH_AVALIABLE_LANGUAGES_REQUEST

  constructor() {}
}

export class FetchAvaliableLanguagesSuccess implements Action {
  readonly type = i18nTypes.FETCH_AVALIABLE_LANGUAGES_SUCCESS
  constructor(public payload: any[]) {}
}

export class FetchAvaliableLanguagesFailure implements Action {
  readonly type = i18nTypes.FETCH_AVALIABLE_LANGUAGES_FAILURE
  constructor(public payload: any) {}
}

export class FetchDefaultTranslationsRequest implements Action {
  readonly type = i18nTypes.FETCH_DEFAULT_TRANSLATIONS_REQUEST

  constructor() {}
}

export class FetchDefaultTranslationsSuccess implements Action {
  readonly type = i18nTypes.FETCH_DEFAULT_TRANSLATIONS_SUCCESS

  constructor(public payload: translation) {}
}

export class FetchDefaultTranslationsFailure implements Action {
  readonly type = i18nTypes.FETCH_DEFAULT_TRANSLATIONS_FAILURE
  constructor(public payload: any) {}
}

export class IsContentEditableEnabled implements Action {
  readonly type = i18nTypes.IS_CONTENT_EDITABLE_ENABLED
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = i18nTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class FetchTranslationsListRequest implements Action {
  readonly type = i18nTypes.FETCH_TRANSLATIONS_LIST_REQUEST
  constructor(public queryParams: any, public iso2code: string) {}
}

export class FetchTranslationsListSuccess implements Action {
  readonly type = i18nTypes.FETCH_TRANSLATIONS_LIST_SUCCESS
  constructor(
    public payload: TranslationRow[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchTranslationsListFailure implements Action {
  readonly type = i18nTypes.FETCH_TRANSLATIONS_LIST_FAILURE
  constructor(public payload: any) {}
}

export class UpdateTranslationManualy implements Action {
  readonly type = i18nTypes.UPDATE_TRANSLATIONS_MANUALY
  constructor(public iso2code: string) {}
}

export class UpdateTranslationManualySuccessfully implements Action {
  readonly type = i18nTypes.UPDATE_TRANSLATIONS_MANUALY_SUCCESSFULLY
  constructor() {}
}

export class UpdateTranslationManualyFailure implements Action {
  readonly type = i18nTypes.UPDATE_TRANSLATIONS_MANUALY_FAILURE
  constructor() {}
}

export type ActionType =
  | FetchAvaliableLanguagesRequest
  | FetchAvaliableLanguagesSuccess
  | FetchAvaliableLanguagesFailure
  | FetchDefaultTranslationsRequest
  | FetchDefaultTranslationsSuccess
  | FetchDefaultTranslationsFailure
  | IsContentEditableEnabled
  | UpdateField
  | FetchTranslationsListRequest
  | FetchTranslationsListSuccess
  | FetchTranslationsListFailure
  | UpdateTranslationManualy
  | UpdateTranslationManualySuccessfully
  | UpdateTranslationManualyFailure
